import { statsApi } from '@api/stats/stats.api';

export const {
  useLoadConsumerStatsQuery,
  useLoadApplicationStatsQuery,
  useLazyLoadApplicationStatsQuery,
  useLoadApplicationChartStatsQuery,
  useLoadApplicationDetailedChartStatsQuery,
} = statsApi;
